export enum BackendType {
    LocalStore = "LocalStore",
    Neo4j = "Neo4j"
}
